<template>
  <div
    class="ws-col"
    :class="[`col-${cols}`,`sm-col-${smcols}`]"
    :style="{
      'justify-content': justifyContent,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: [Number, String],
      default: 6,
    },
    smcols: {
      type: [Number, String],
      default: 12,
    },
    justifyContent: {
      type: String,
    }
  },
};
</script>